import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { withTranslation } from "react-i18next";
import Loader from "../../../../Common/Loader/loader";
import { useNavigate } from "react-router-dom";
// import DataTable from "react-data-table-component";
// import { useNavigate } from "react-router-dom";
import {
  AllTripsTonnage,
  ZonewiseTripsReport, GHMCTripsReport, HIRETripsReport, HIMSWTripsReport, TotalTripsReport, GHMCTonnageReport, HIRETonnageReport, HIMSWTonnageReport, TotalTonnageReport, AllULBReport,
  ZonewiseULBReport, HIRETotalTripsReport, HIMSWTotalTripsReport, TotalWithTripsReport,
  GHMCTripsTotalReport, GHMCTonnageTotalReport, HIRETonnageTotalReport, HIMSWTonnageTotalReport, TotalTonnageWithReport
} from "../../../../Apis/ttrReportsApi";
import CustomDataTable from "../../../../Common/ReportTable/ReportTable";
import ExcelJS from "exceljs";
import isGHMC from "../../../../Common/helper/helpar";
import { getNowDateTime, getOneMonthPastDateTime } from "../../../AssetVehicle/utils/helpers";
const HookLoaderReport = ({ t }) => {
  const TonnageFromDate = localStorage.getItem("TonnageFromDate")
  const TonnageToDate = localStorage.getItem("TonnageToDate")
  const navigate = useNavigate();
  const [getAllTripsTonnage, setAllTripsTonnage] = useState([]);
  const [startDate, setStartDate] = useState(TonnageFromDate || getStartOfCurrentDate());
  const [endDate, setEndDate] = useState(TonnageToDate || getCurrentDateTime());
  const [isLoading, setIsLoading] = useState(false);
  const [isOptionsLoading, setIsOptionsLoading] = useState(false);
  const [getAllULB, setAllULB] = useState([]);
  const [showULBTable, setShowULBTable] = useState(true);
  const [formInput, setFormInput] = useState({
    Date: getCurrentDateTime(),
  });
  const isProd = isGHMC();

  const fetchTripsTonnageData = async () => {
    try {
      setIsLoading(true);
      const response = await AllTripsTonnage(startDate, endDate);
      setAllTripsTonnage(response.data);
    } catch (error) {
      console.error("Error fetching overall SCV trips data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleToggleULBTable = async () => {
    try {
      setIsOptionsLoading(true);
      if (!showULBTable) {
        const response = await AllULBReport(startDate, endDate);
        setAllULB(response.data);
      }
      setShowULBTable(!showULBTable);
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  useEffect(() => {

    fetchTripsTonnageData();
  }, []);
  useEffect(() => {
    handleToggleULBTable();
  }, []);
  const tripsColumns = [
    {
      name: "S.No",
      selector: (row) => row["slno"],
      //   sortable: true,
      width: "120px",
      format: (row, rowIndex) => rowIndex + 1,
      width: "70px",
    },
    {
      name: "Zone",
      selector: (row) => row["zoneName"],
      cell: (row) => (
        <span
          style={{ color: `${row.zoneName === "Total" ? "black" : "blue"}`, cursor: "pointer" }}
          onClick={() => row.zoneName != "Total" && handleZoneClick(row)}
        >
          {row["zoneName"]}
        </span>
      ),
      //    sortable: true,
      width: "150px",
    },
    {
      name: <>GHMC Trips</>,
      selector: (row) => row["ghmcTrips"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          // onClick={() => handleGHMCTripsClick(row)}
          onClick={() => {
            if (row.zoneName === 'Total') {
              handleTotalGHMCClick()
            } else {
              handleGHMCTripsClick(row)
            }
          }}
        >
          {" "}
          {row["ghmcTrips"]}
        </span>
      ),
      //    sortable: true,
      width: "120px",
    },
    {
      name: <>HIRE Trips</>,
      selector: (row) => row["hireTrips"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === 'Total') {
              handleTotalHIREClick()
            } else {
              handleHIREClick(row)
            }
          }}
        >
          {row["hireTrips"]}
        </span>
      ),
      //    sortable: true,
      width: "120px",
    },
    {
      name: <>HIMSW Trips</>,
      selector: (row) => row["himswTrips"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === 'Total') {
              handleTotalHIMSWClick()
            } else {
              handleHIMSWClick(row)
            }
          }}
        >
          {row["himswTrips"]}
        </span>
      ),
      //    sortable: true,
      width: "120px",
    },
    {
      name: <>Total Trips</>,
      selector: (row) => row["totalTrips"],
      cell: (row) => (

        <span
          style={{ color: "blue", cursor: "pointer" }}
          // onClick={() => handleTotalClick(row)}
          onClick={() => {
            if (row.zoneName === 'Total') {
              handleTotalWithClick()
            } else {
              handleTotalClick(row)
            }
          }}
        >
          {row["totalTrips"]}
        </span>
      ),
      //    sortable: true,
      width: "120px",
    },
    {
      name: <>GHMC Tonnage</>,
      selector: (row) => row["ghmcTonnage"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          // onClick={() => handleTonnageGHMCClick(row)}
          onClick={() => {
            if (row.zoneName === 'Total') {
              handleTotalTonnageGHMCClick()
            } else {
              handleTonnageGHMCClick(row)
            }
          }}
        >
          {row["ghmcTonnage"] / 1000}
        </span>
      ),
      //    sortable: true,
      // width: "150px",
    },
    {
      name: <>HIRE Tonnage</>,
      selector: (row) => row["hireTonnage"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          // onClick={() => handleHIRETonnageClick(row)}
          onClick={() => {
            if (row.zoneName === 'Total') {
              handleHIRETotalTonnageGHMCClick()
            } else {
              handleHIRETonnageClick(row)
            }
          }}
        >
          {row["hireTonnage"] / 1000}
        </span>
      ),
      //    sortable: true,
      // width: "120px",
    },
    {
      name: <>HIMSW Tonnage</>,
      selector: (row) => row["himswTonnage"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === 'Total') {
              handleHIMSWTotalTonnageClick()
            } else {
              handleHIMSWTonnageClick(row)
            }
          }}
        // onClick={() => handleHIMSWTonnageClick(row)}
        >
          {row["himswTonnage"] / 1000}
        </span>
      ),
      //    sortable: true,
      width: "150px",
    },
    {
      name: <>Total Tonnage</>,
      selector: (row) => row["totalTonnage"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          //  onClick={() => handleTotalTonnageClick(row)}
          onClick={() => {
            if (row.zoneName === 'Total') {
              handleTotalTonnageWithClick()
            } else {
              handleTotalTonnageClick(row)
            }
          }}
        >
          {row["totalTonnage"] / 1000}
        </span>
      ),
      //     sortable: true,
      // width: "150px",
    },
  ];
  const ulbColumns = [
    {
      name: "S.No",
      selector: (row) => row["slno"],
      //    sortable: true,
      width: "120px",
      format: (row, rowIndex) => rowIndex + 1,
      width: "100px",
    },
    {
      name: "Zone",
      selector: (row) => row["zoneName"],
      cell: (row) => (
        <span
          // key={zone.zoneId}
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => handleZoneULBClick(row)}
        >
          {row["zoneName"]}
        </span>
      ),
      //     sortable: true,
      width: "120px",
    },
    {
      name: "Trips",
      selector: (row) => row["trips"],
      cell: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        //   onClick={() => handleGHMCTripsClick(row)}
        >
          {" "}
          {row["trips"]}
        </span>
      ),
      //     sortable: true,
      width: "120px",
    },
    {
      name: "Tonnage",
      selector: (row) => row["tonnage"],
      cell: (row) => (
        <span
        //  style={{ color: "blue", cursor: "pointer" }}
        // onClick={() => handleHIREClick(row)}
        >
          {row["tonnage"]}
        </span>
      ),
      //   sortable: true,
      // width: "120px"
    },
  ];
  const handleFormSubmit = (e) => {
    e.preventDefault();
    // Call API with startDate and endDate values
    fetchTripsTonnageData(startDate, endDate);
  };
  const handleZoneULBClick = async (zone) => {
    try {
      setIsOptionsLoading(true);
      console.log("Zone object: ", zone);
      const requestData = {
        startDate,
        endDate,
        zoneId: zone.zoneId,
      }
      console.log("Request Data: ", requestData);
      const response = await ZonewiseULBReport(startDate, endDate, requestData.zoneId);
      navigate("/zone-ulb", { state: response.data });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleZoneClick = async (zone) => {
    try {
      setIsOptionsLoading(true);
      console.log("zoneeeesssss", zone)
      const requestData = {
        startDate,
        endDate,
        zoneId: zone.zoneId,
      }
      const response = await ZonewiseTripsReport(startDate, endDate, requestData.zoneId);
      navigate("/zone-trips-tonnage", { state: response.data });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleGHMCTripsClick = async (zone) => {
    try {
      setIsOptionsLoading(true);
      const requestData = {
        startDate,
        endDate,
        zoneId: zone.zoneId,
        Transporter: "GHMC",
      }
      const response = await GHMCTripsReport(startDate, endDate, requestData.zoneId, requestData.Transporter,);
      navigate("/ghmc-trips-tonnage", { state: response.data });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleTotalGHMCClick = async () => {
    try {
      setIsOptionsLoading(true);
      const requestData = {
        startDate,
        endDate,
        Transporter: "GHMC",
      }
      const response = await GHMCTripsTotalReport(startDate, endDate, requestData.Transporter,);
      navigate("/ghmc-trips-tonnage", { state: response.data });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleHIREClick = async (zone) => {
    try {
      setIsOptionsLoading(true);
      const requestData = {
        startDate,
        endDate,
        zoneId: zone.zoneId,
        Transporter: "Private",
      }
      const response = await HIRETripsReport(startDate, endDate, requestData.zoneId, requestData.Transporter,);
      navigate("/hire-trips-tonnage", { state: response.data });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleTotalHIREClick = async () => {
    try {
      setIsOptionsLoading(true);
      const requestData = {
        startDate,
        endDate,
        // zoneId: zone.zoneId,
        Transporter: "Private",
      }
      const response = await HIRETotalTripsReport(startDate, endDate, requestData.Transporter,);
      navigate("/hire-trips-tonnage", { state: response.data });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleHIMSWClick = async (zone) => {
    try {
      setIsOptionsLoading(true);
      const requestData = {
        startDate,
        endDate,
        zoneId: zone.zoneId,
        Transporter: "HIMSW",
      }
      const response = await HIMSWTripsReport(startDate, endDate, requestData.zoneId, requestData.Transporter,);
      navigate("/himsw-trips-tonnage", { state: response.data });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleTotalHIMSWClick = async () => {
    try {
      setIsOptionsLoading(true);
      const requestData = {
        startDate,
        endDate,
        Transporter: "HIMSW",
      }
      const response = await HIMSWTotalTripsReport(startDate, endDate, requestData.Transporter,);
      navigate("/himsw-trips-tonnage", { state: response.data });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleTotalClick = async (zone) => {
    try {
      setIsOptionsLoading(true);
      const requestData = {
        startDate,
        endDate,
        zoneId: zone.zoneId,
      }
      const response = await TotalTripsReport(startDate, endDate, requestData.zoneId);
      navigate("/total-trips-tonnage", { state: response.data });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleTotalWithClick = async () => {
    try {
      setIsOptionsLoading(true);
      const requestData = {
        startDate,
        endDate,
      }
      const response = await TotalWithTripsReport(startDate, endDate);
      navigate("/total-trips-tonnage", { state: response.data });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleTonnageGHMCClick = async (zone) => {
    try {
      setIsOptionsLoading(true);
      const requestData = {
        startDate,
        endDate,
        zoneId: zone.zoneId,
        Transporter: "GHMC",
      }
      const response = await GHMCTonnageReport(startDate, endDate, requestData.zoneId, requestData.Transporter);
      navigate("/ghmc-tonnage", { state: response.data });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleTotalTonnageGHMCClick = async () => {
    try {
      setIsOptionsLoading(true);
      const requestData = {
        startDate,
        endDate,
        Transporter: "GHMC",
      }
      const response = await GHMCTonnageTotalReport(startDate, endDate, requestData.Transporter);
      navigate("/ghmc-tonnage", { state: response.data });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleHIRETonnageClick = async (zone) => {
    try {
      setIsOptionsLoading(true);
      const requestData = {
        startDate,
        endDate,
        zoneId: zone.zoneId,
        Transporter: "Private",
      }
      const response = await HIRETonnageReport(startDate, endDate, requestData.zoneId, requestData.Transporter);
      navigate("/hire-tonnage", { state: response.data });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleHIRETotalTonnageGHMCClick = async () => {
    try {
      setIsOptionsLoading(true);
      const requestData = {
        startDate,
        endDate,
        Transporter: "Private",
      }
      const response = await HIRETonnageTotalReport(startDate, endDate, requestData.Transporter);
      navigate("/hire-tonnage", { state: response.data });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleHIMSWTonnageClick = async (zone) => {
    try {
      setIsOptionsLoading(true);
      const requestData = {
        startDate,
        endDate,
        zoneId: zone.zoneId,
        Transporter: "HIMSW",
      }
      const response = await HIMSWTonnageReport(startDate, endDate, requestData.zoneId, requestData.Transporter);
      navigate("/himsw-tonnage", { state: response.data });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleHIMSWTotalTonnageClick = async () => {
    try {
      setIsOptionsLoading(true);
      const requestData = {
        startDate,
        endDate,
        Transporter: "HIMSW",
      }
      const response = await HIMSWTonnageTotalReport(startDate, endDate, requestData.Transporter);
      navigate("/himsw-tonnage", { state: response.data });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleTotalTonnageClick = async (zone) => {
    try {
      setIsOptionsLoading(true);
      const requestData = {
        startDate,
        endDate,
        zoneId: zone.zoneId,
        Transporter: "HIMSW",
      }
      const response = await TotalTonnageReport(startDate, endDate, requestData.zoneId, requestData.Transporter);
      navigate("/total-tonnage", { state: response.data });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleTotalTonnageWithClick = async () => {
    try {
      setIsOptionsLoading(true);
      const requestData = {
        startDate,
        endDate,
        Transporter: "HIMSW",
      }
      const response = await TotalTonnageWithReport(startDate, endDate, requestData.Transporter);
      navigate("/total-tonnage", { state: response.data });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };


  const calculateSCVOverallTotals = (data) => {
    const totals = {
      sno: 'Total',
      zoneName: 'Total',
      ghmcTrips: 0,
      hireTrips: 0,
      himswTrips: 0,
      totalTrips: 0,
      ghmcTonnage: 0,
      hireTonnage: 0,
      himswTonnage: 0,
      totalTonnage: 0
    };

    data.forEach(row => {
      totals.ghmcTrips += row.ghmcTrips || 0;
      totals.hireTrips += row.hireTrips || 0;
      totals.himswTrips += row.himswTrips || 0;
      totals.totalTrips += row.totalTrips || 0;
      totals.ghmcTonnage += row.ghmcTonnage || 0;
      totals.hireTonnage += row.hireTonnage || 0;
      totals.himswTonnage += row.himswTonnage || 0;
      totals.totalTonnage += row.totalTonnage || 0;
    });
    return totals;
  };

  const totalZoneRow = calculateSCVOverallTotals(getAllTripsTonnage);
  const TripsTonnageDataWithTotal = [...getAllTripsTonnage, totalZoneRow];


  const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
  const generationTime = ` ${new Date().toLocaleString('en-GB', options).replace(/\//g, '/')}`;

  // const downloadAsExcel = async () => {
  //   // Create a new workbook and add a worksheet
  //   const currentDate = new Date();
  //   const formattedDate = `${currentDate.getFullYear()}-${
  //     currentDate.getMonth() + 1
  //   }-${currentDate.getDate()}`;
  //   const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
  //   const downloadDateTime = `Trips Report Generated on: ${generationTime},${formattedTime}`;
  //   // Calculate the length of the downloadDateTime string
  //   const downloadDateTimeLength = downloadDateTime.length;
  //   const workbook = new ExcelJS.Workbook();
  //   const worksheet = workbook.addWorksheet("Trips&Tonnage");

  //   // Define styles
  //  const boldFont = { bold: true };

  // // Add the downloadDateTime to the correct row and columns, and ensure formatting
  // worksheet.addRow(["", "", downloadDateTime, ""]); // Update array length to match new cell range
  // worksheet.mergeCells(1, 2, 1, 4); // Merge cells for downloadDateTime from column 2 to 4
  // worksheet.getCell(1, 2).value = downloadDateTime; // Ensure the value is set after merging
  // worksheet.getCell(1, 2).font = boldFont; // Set font style
  // worksheet.getCell(1, 2).alignment = { horizontal: "center" }; // Center align the content

  // // Apply styles to the merged cells (B1, C1, D1)
  // for (let col = 2; col <= 4; col++) {
  //   worksheet.getCell(1, col).font = boldFont; // Set styles individually
  //   worksheet.getCell(1, col).alignment = { horizontal: "center" }; // Center align the cell content
  // }

  // // Add "Zone Details" to the correct row and columns, and ensure formatting
  // worksheet.addRow(["", "", "Trips&Tonnage Details", ""]); // Update array length to match new cell range
  // worksheet.mergeCells(2, 2, 2, 4); // Merge cells for Zone Details from column 2 to 4
  // worksheet.getCell(2, 2).value = "Trips&Tonnage Details"; // Ensure the value is set after merging
  // worksheet.getCell(2, 2).font = boldFont; // Set font style
  // worksheet.getCell(2, 2).alignment = { horizontal: "center" }; // Center align the content

  // // Apply styles to the merged cells (B2, C2, D2)
  // for (let col = 2; col <= 4; col++) {
  //   worksheet.getCell(2, col).font = boldFont; // Set styles individually
  //   worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
  // }




  //   // worksheet.addRow(["", "", "", "", downloadDateTime, "", "", "", ""]);
  //   // worksheet.mergeCells(2, 5, 2, 8); // Merge cells for downloadDateTime
  //   // for (let col = 5; col <= 8; col++) {
  //   //   worksheet.getCell(2, col).font = boldFont; // Set styles individually
  //   //   worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
  //   // }

  //   // Add table header row with bold font
  //   const tableHeaderRow = worksheet.addRow([
  //     "Sno",
  //     "Zone",
  //     "GHMC Trips",
  //     "HIRE Trips",
  //     "HIMSW Trips",
  //     "Total Trips",
  //     "GHMC Tonnage",
  //     "HIRE Tonnage",
  //     "HIMSW Tonnage",
  //     "Total Tonnage"
  //   ]);
  //   tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
  //     cell.font = boldFont;
  //     cell.alignment = { horizontal: "left",color:"#fff" }; // Center align the cell content
  //     if (colNumber >= 1 && colNumber <= 10) {
  //       // Apply background color and set text color
  //       cell.fill = {
  //         type: "pattern",
  //         pattern: "solid",
  //         fgColor: { argb: "F6B1B1" }, // Red background color
  //         bgColor: { argb: "FFFFFFFF" } // White text color
  //       };
  //     }
  //   });

  //   // Add data rows
  //   getAllTripsTonnage.forEach((item, index) => {

  //     worksheet
  //       .addRow([
  //         index + 1,
  //    item.zoneName,
  //       item.ghmcTrips,
  //        item.hireTrips,
  //      item.himswTrips,
  //      item.totalTrips,
  //      item.ghmcTonnage,
  //      item.hireTonnage,
  //      item.himswTonnage,
  //      item.totalTonnage

  //       ])
  //       .eachCell({ includeEmpty: true }, (cell, colNumber) => {
  //         if (colNumber >= 1 && colNumber <= 10) {
  //           // Align the columns from 1 to 4 to the left
  //           cell.alignment = { horizontal: "left" };
  //         } else {
  //           // Align the rest of the columns to the center
  //           cell.alignment = { horizontal: "center" };
  //         }
  //       });
  //   });

  //   // Add total row with bold font


  //   // Set column widths dynamically based on content
  //   worksheet.columns = [
  //     { width: 5 },
  //     { width: 20 },
  //     { width: 20 },
  //     { width: 20 },
  //     { width: 20 },
  //     { width: 15 },
  //     { width: 15 },
  //     { width: 15 },
  //     { width: 15 },
  //     { width: 15 },
  //   ];

  //   // Save the workbook to a file
  //   const buffer = await workbook.xlsx.writeBuffer();
  //   const blob = new Blob([buffer], {
  //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //   });
  //   const url = URL.createObjectURL(blob);
  //   const a = document.createElement("a");
  //   a.href = url;
  //   a.download = "trips&tonnage.xlsx";
  //   a.click();
  //   URL.revokeObjectURL(url);
  // };
  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `Trips Report Generated on: ${generationTime}, ${formattedTime}`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Trips&Tonnage");

    // Define styles
    const boldFont = { bold: true };

    // Add the downloadDateTime to the worksheet
    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 4);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    // Apply styles to the merged cells
    for (let col = 2; col <= 4; col++) {
      worksheet.getCell(1, col).font = boldFont;
      worksheet.getCell(1, col).alignment = { horizontal: "center" };
    }

    // Add "Zone Details" to the worksheet
    worksheet.addRow(["", "", "Trips&Tonnage Details", ""]);
    worksheet.mergeCells(2, 2, 2, 4);
    worksheet.getCell(2, 2).value = "Trips&Tonnage Details";
    worksheet.getCell(2, 2).font = boldFont;
    worksheet.getCell(2, 2).alignment = { horizontal: "center" };

    // Apply styles to the merged cells
    for (let col = 2; col <= 4; col++) {
      worksheet.getCell(2, col).font = boldFont;
      worksheet.getCell(2, col).alignment = { horizontal: "center" };
    }

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "Sno",
      "Zone",
      "GHMC Trips",
      "HIRE Trips",
      "HIMSW Trips",
      "Total Trips",
      "GHMC Tonnage",
      "HIRE Tonnage",
      "HIMSW Tonnage",
      "Total Tonnage"
    ]);
    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" };
      if (colNumber >= 1 && colNumber <= 10) {
        // Apply background color
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Light red background
        };
      }
    });

    // Initialize totals
    let totalGhmcTrips = 0;
    let totalHireTrips = 0;
    let totalHimswTrips = 0;
    let totalTrips = 0;
    let totalGhmcTonnage = 0;
    let totalHireTonnage = 0;
    let totalHimswTonnage = 0;
    let totalTonnage = 0;

    // Add data rows
    getAllTripsTonnage.forEach((item, index) => {
      worksheet.addRow([
        index + 1, // S.No
        item.zoneName ?? "N/A",
        item.ghmcTrips ?? "N/A",
        item.hireTrips ?? "N/A",
        item.himswTrips ?? "N/A",
        item.totalTrips ?? "N/A",
        item.ghmcTonnage ?? "N/A",
        item.hireTonnage ?? "N/A",
        item.himswTonnage ?? "N/A",
        item.totalTonnage ?? "N/A"
      ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber >= 1 && colNumber <= 10) {
          // Align columns from 1 to 4 to the left
          cell.alignment = { horizontal: "left" };
        } else {
          // Align the rest of the columns to the center
          cell.alignment = { horizontal: "center" };
        }
      });

      // Accumulate totals
      totalGhmcTrips += item.ghmcTrips || 0;
      totalHireTrips += item.hireTrips || 0;
      totalHimswTrips += item.himswTrips || 0;
      totalTrips += item.totalTrips || 0;
      totalGhmcTonnage += item.ghmcTonnage || 0;
      totalHireTonnage += item.hireTonnage || 0;
      totalHimswTonnage += item.himswTonnage || 0;
      totalTonnage += item.totalTonnage || 0;
    });

    // Add total row (no S.No for the total row)
    const totalRow = worksheet.addRow([
      "", // Leave S.No empty for the total row
      'Total', // Label the total row as "Total"
      totalGhmcTrips,
      totalHireTrips,
      totalHimswTrips,
      totalTrips,
      totalGhmcTonnage,
      totalHireTonnage,
      totalHimswTonnage,
      totalTonnage
    ]);

    totalRow.eachCell({ includeEmpty: true }, (cell) => {
      cell.font = boldFont; // Make the total row bold
      cell.alignment = { horizontal: "left" }; // Center align the total row
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },   // S.No
      { width: 20 },  // Zone
      { width: 20 },  // GHMC Trips
      { width: 20 },  // HIRE Trips
      { width: 20 },  // HIMSW Trips
      { width: 20 },  // Total Trips
      { width: 15 },  // GHMC Tonnage
      { width: 15 },  // HIRE Tonnage
      { width: 15 },  // HIMSW Tonnage
      { width: 15 }   // Total Tonnage
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "trips&tonnage.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };


  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <h4 class="text-start mb-3"> Trips & Tonnage Reports</h4>
            <div className="page-header">
              <div className="card mb-3">
                <div className="card-body">
                  <form onSubmit={handleFormSubmit}>

                    <div className="row align-items-end" style={{ textAlign: "left" }}>
                      <div className="col-md-3">
                        <label >From Date & Time:</label>
                        <input
                          type="datetime-local"
                          name="fromDate"
                          className="form-control"
                          value={startDate}
                          onChange={(e) => {
                            setStartDate(e.target.value)
                            localStorage.setItem("TonnageFromDate", e.target.value)
                          }}
                          min={getOneMonthPastDateTime()}
                          max={getNowDateTime()}
                        
                        />
                      </div>
                      <div className="col-md-3">
                        <label >To Date & Time:</label>
                        <input
                          type="datetime-local"
                          name="toDate"
                          className="form-control"
                          value={endDate}
                          min={startDate}
                          max={getCurrentDateTime()}
                          onChange={(e) => {
                            setEndDate(e.target.value)
                            localStorage.setItem("TonnageToDate", e.target.value)
                          }}
                        />
                      </div>
                      <div className="col-md-3">
                        <button type="submit"
                          className={`btn mt-4 mr-2 ${isProd ? "search-ghmc" : "search-swm"}`}

                        >
                          Search
                        </button>
                        <button type="reset"
                          className={`btn mt-4 ${isProd ? "search-ghmc" : "search-swm"}`}
                          onClick={() => {
                            localStorage.removeItem("TonnageFromDate")
                            localStorage.removeItem("TonnageToDate")
                            setStartDate(getStartOfCurrentDate())
                            setEndDate(getStartOfCurrentDate())
                          }}
                        >
                          Reset
                        </button>
                      </div>
                      <div className="col-md-3">
                        <div className="d-flex justify-content-around align-items-end ">
                          <button
                            className={`btn mt-4 ${isProd ? "search-ghmc" : "search-swm"}`}
                            type="submit"
                            onClick={handleToggleULBTable} >
                            {showULBTable ? 'Hide ULB' : 'Show ULB'}
                          </button>
                          <button className="btn btn-excelnew ms-2" onClick={() => downloadAsExcel(getAllTripsTonnage)}>
                            <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>

                  <div className=" mt-3">

                  </div>
                  <div className="card ">
                    <div className="card-body">
                      <CustomDataTable data={TripsTonnageDataWithTotal}
                        columns={tripsColumns}
                      />
                    </div>
                  </div>
                  {showULBTable && (
                    <div className="card">
                      <div className="card-body">
                        {/* Replace the content inside with your ULB table component */}
                        <CustomDataTable data={getAllULB} columns={ulbColumns} />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && <Loader />}
    </>
  );
};

export default withTranslation()(HookLoaderReport);

const getStartOfCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00`;
};

const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hour}:${minute}`;
};

const inputStyle = {
  backgroundColor: "#fff",
  height: "40px",
  width: "250px",
  border: "1px solid #E2E2E2",
  padding: "15px",
  borderRadius: "0px",

};

const buttonStyle = {
  backgroundColor: "#E21E26",
  height: "40px",
  minWidth: "80px",
  border: "1px solid #E2E2E2",
  marginTop: "20px",
  borderRadius: "5px",
  color: "#fff",
};

